<table class="search-table linked-collection-table">
  <thead>
    <tr>
      <th>
        {{ "Screens.UserSettings.Details.Subscriptions.Name" | translate }}
      </th>
      <th>
        {{ "Screens.UserSettings.Details.Subscriptions.Description" | translate
        }}
      </th>
      <th>
        {{ "Screens.UserSettings.Details.Subscriptions.Clinics" | translate }}
      </th>
      <th class="text-center">
        {{ "Screens.UserSettings.Details.Subscriptions.Given" | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="
        let userSubscription of records;
        let index = index;
        let odd = odd;
        let even = even
      "
      [ngClass]="{
        odd: odd,
        even: even,
        'd-none': !userSubscription.id && userSubscription.$$markedAsDeleted
      }"
      [class.strikeout]="userSubscription.$$markedAsDeleted"
    >
      <td>{{ userSubscription.name }}</td>
      <td>{{ userSubscription.description }}</td>
      <td
        ngModelGroup="userSubscriptionIdModelGroup"
        uniqueCollectionValidator
        style="width: 50%"
      >
        <waf-select-input
          #clinicInfo
          name="userSubscriptionClinicId-{{ index }}"
          [(ngModel)]="userSubscription.clinicIds"
          (ngModelChange)="collectionChanged.emit()"
          [options]="clinicInitOptions"
          [multiple]="true"
          [disabled]="!(userSubscription.id)"
        >
        </waf-select-input>
      </td>

      <td>
        <waf-boolean-input
          name="removeRow-{{ index }}"
          [(ngModel)]="userSubscription.isActive"
          (ngModelChange)="userSubscription.hasChanged = true;"
        ></waf-boolean-input>
      </td>
    </tr>
  </tbody>
</table>
